import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/quality-assurance/outsourced-qa")({
  beforeLoad: () => { throw redirect({ to: "/en/services/quality-assurance/qa-support-outsourcing", statusCode: 301 }); },
});
